import { createFileRoute } from '@tanstack/react-router';
import { Content } from '@/components/ui/content';
import { meta } from '@/lib/meta';
import { SetlistEditor } from './+components/setlist-editor';

export const Route = createFileRoute('/_app/setlists/create')({
  head: () => meta({ label: 'Novo repertório' }),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <Content
      breadcrumbs={{
        icon: 'list-music',
        title: 'Novo repertório',
        items: [
          { label: 'Repertórios', route: '/setlists' },
          { label: 'Novo', active: true },
        ],
      }}
    >
      <SetlistEditor />
    </Content>
  );
}
